import {
  NewUserRequest,
  OrganizationRepresentation,
  UserOrganizationAccess,
  UserToDelete,
} from "../infrastructure/api/api";
import { getJSON, post, remove } from "../infrastructure/api/digipost-fetch";
import { cached, invalidate } from "../infrastructure/api/cache";
import {
  findUriIfExists,
  MissingLinkError,
} from "../infrastructure/entrypoint/link";

export interface UsersApi {
  listUsers: () => Promise<UserOrganizationAccess[]>;
  canManageUsers: () => boolean;
  addUser: (request: NewUserRequest) => Promise<UserOrganizationAccess>;
  deleteUser: (nin: string) => Promise<void>;
}

export function usersApi(organization: OrganizationRepresentation): UsersApi {
  const usersUrl = findUriIfExists("users", organization._links);
  const addUserUrl = findUriIfExists("add_user", organization._links);
  const deleteUserUrl = findUriIfExists("delete_user", organization._links);

  const listUsers = (): Promise<UserOrganizationAccess[]> =>
    usersUrl
      ? cached(usersUrl, () => getJSON<UserOrganizationAccess[]>(usersUrl))
      : Promise.resolve([]);

  const invalidateUsers = () => {
    if (usersUrl) {
      invalidate(usersUrl);
    }
  };

  return {
    listUsers,

    canManageUsers: () => Boolean(addUserUrl && deleteUserUrl),

    addUser: async (request) => {
      if (!addUserUrl) {
        throw new MissingLinkError("add_user");
      }

      const response = await post(addUserUrl, request);
      invalidateUsers();

      return response.json();
    },

    deleteUser: async (nin) => {
      if (!deleteUserUrl) {
        throw new MissingLinkError("delete_user");
      }

      const body: UserToDelete = { nin };
      await remove(deleteUserUrl, "", body);
      invalidateUsers();
    },
  };
}
